import { createContext, useContext } from 'react';

export const CompositionDisplayContext = createContext<'compact' | 'per_item'>('compact');
export const useCompositionDisplayMode = () => useContext(CompositionDisplayContext);
